import { createContext, useContext } from "react";

/** What a chip needs to know about the person behind a `giraffe-user:<id>` token (SA-04 §5). */
export interface MentionPerson {
  /** The live label (`userLabel`, the same in every locale; GRF-61). */
  name: string;
  active: boolean;
}

export interface MentionDirectory {
  /** The person for a token id, or null when the viewer's directory does not have them (partner view, anonymised). */
  resolve(id: string): MentionPerson | null;
  /** The signed-in person's own id, so a chip naming the viewer can carry a stronger style. */
  selfId: string | null;
}

/** No directory: every chip shows the label snapshot written in the body. */
export const EMPTY_MENTION_DIRECTORY: MentionDirectory = { resolve: () => null, selfId: null };

/**
 * Provided once from AppShell off `useUserDirectory()` (SA-04 §5), so `Markdown` with `mentions` can show a live
 * name for a renamed person and a muted chip for a deactivated one without every comment list fetching users.
 */
export const MentionDirectoryContext = createContext<MentionDirectory>(EMPTY_MENTION_DIRECTORY);

export function useMentionDirectory(): MentionDirectory {
  return useContext(MentionDirectoryContext);
}
